import { Controller } from '@hotwired/stimulus';

/*
eslint class-methods-use-this:
["error", { "exceptMethods": ["remove", "add", "updateFeatured", "batchAction",
                              "batchCheckboxUpdate"] }]
*/
export default class extends Controller {
  connect () {
    this.batchCheckboxUpdate();

    document.addEventListener('turbo:before-stream-render', (event) => {
      if (event.target.action === 'replace') {
        this.batchCheckboxUpdate();
      }
    });
  }

  remove (event) {
    const deleteForm = event.target.closest('tr').querySelector('#form-delete');
    const submit = deleteForm.querySelector('.js-row__submit');
    submit.click();
  }

  add (event) {
    const addForm = event.target.closest('tr').querySelector('#form-create');
    const submit = addForm.querySelector('.js-row__submit');
    submit.click();
  }

  updateFeatured (event) {
    const editForm = event.target.closest('tr').querySelector('#form-update');
    const submit = editForm.querySelector('.js-row__submit');
    submit.click();
  }

  batchAction (event) {
    const batchCheckbox = event.target;

    if (batchCheckbox.checked) {
      const createForm = batchCheckbox.closest('th').querySelector('#form-create-all');
      const submit = createForm.querySelector('.js-row__submit');
      submit.click();
    } else {
      const destroyForm = batchCheckbox.closest('th').querySelector('#form-delete-all');
      const submit = destroyForm.querySelector('.js-row__submit');
      submit.click();
    }
  }

  batchCheckboxUpdate () {
    const batchCheckbox = document.querySelector('#batch-action-checkbox');
    if (batchCheckbox) {
      const checkBoxes = document.querySelector('#all-programs-table')
        .querySelectorAll('.program-checkbox');
      const checkedCount = Array.from(checkBoxes).filter(checkbox => checkbox.checked).length;
      if (checkedCount === 0) {
        batchCheckbox.checked = false;
        batchCheckbox.indeterminate = false;
      } else if (checkBoxes.length === checkedCount) {
        batchCheckbox.checked = true;
        batchCheckbox.indeterminate = false;
      } else {
        batchCheckbox.checked = false;
        batchCheckbox.indeterminate = true;
      }
    }
  }
}
